export const STEP = {
  WAIT: "wait",
  ACTIVE: "active",
  DONE: "done",
  ERROR: "error",
  SKIP: "skip",
};

export function countTasks(entity) {
  if (!entity) {
    return { done: 0, total: 0 };
  }
  let total = (entity.Tasks || []).length;
  if (entity.expected_tasks) {
    try {
      total = JSON.parse(entity.expected_tasks).length;
    } catch (e) {
      // keep the number of known tasks
    }
  }
  const done = (entity.Tasks || []).filter(
    (task) => task.status && task.status !== "pending"
  ).length;
  return { done: Math.min(done, total), total };
}

export function mainStep(main) {
  if (main.status === "error") return STEP.ERROR;
  if (main.status === "success") return STEP.DONE;
  return STEP.ACTIVE;
}

const WALLET_STEP = {
  waiting: STEP.WAIT,
  running: STEP.ACTIVE,
  done: STEP.DONE,
  error: STEP.ERROR,
  skipped: STEP.SKIP,
};

/**
 * Sequential steps: main company, optional currency wallet, branch, link.
 * The attach flow has no branch to build, so it only shows the wallet (if any)
 * and the link.
 */
export function branchSteps(main, plan) {
  const mainState = mainStep(main);
  const failedAt = plan.failed_step;
  const wallet = plan.currency_wallet
    ? WALLET_STEP[plan.currency_wallet.state]
    : null;

  if (plan.mode === "attach") {
    const link = {
      waiting: STEP.WAIT,
      running: STEP.WAIT,
      linking: STEP.ACTIVE,
      done: STEP.DONE,
      error: STEP.ERROR,
      skipped: STEP.SKIP,
    }[plan.state];
    return { main: mainState, wallet, branch: STEP.WAIT, link };
  }

  let branch = STEP.WAIT;
  let link = STEP.WAIT;
  if (plan.state === "skipped") {
    branch = STEP.SKIP;
    link = STEP.SKIP;
  } else if (plan.state === "running") {
    branch = STEP.ACTIVE;
  } else if (plan.state === "linking") {
    branch = STEP.DONE;
    link = STEP.ACTIVE;
  } else if (plan.state === "done") {
    branch = STEP.DONE;
    link = STEP.DONE;
  } else if (plan.state === "error") {
    if (failedAt === "link") {
      branch = STEP.DONE;
      link = STEP.ERROR;
    } else {
      branch = STEP.ERROR;
      link = STEP.SKIP;
    }
  }
  return { main: mainState, wallet, branch, link };
}

export function hasWalletError(plan) {
  return Boolean(
    plan && plan.currency_wallet && plan.currency_wallet.state === "error"
  );
}
